import React from "react";
import PropTypes from "prop-types";

export default function Warning({
  children,
  enableIcon = true,
  warningType = "warning"
}) {
  return (
    <div className={`center-block alert alert-${warningType}`}>
      <div className="media">
        <div className="media-left">
          {enableIcon && (
            <i className={`fa fa-lg fa-warning text-${warningType}`} />
          )}
        </div>
        <div className="media-body">{children}</div>
      </div>
    </div>
  );
}

Warning.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  warningType: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Warning/Warning.jsx